import React from "react"
import HospitalExpenses from "./HospitalExpenses"
export default function ClaimExpenses(props) {


  return (
    <HospitalExpenses {...props} />
  )
}